<script>
export default {
    name: 'FeeTemplateModal',
    props: {
        fees: Array,
        modalTitle: String,
    },
    computed: {
        filtered(){
            let data = this.fees;
            var total = this.currentPage * this.perPage;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.name
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPage, total);
            if (this.currentPage > 1 && currentData.length == 0) {
                total = (this.currentPage - 1) * this.perPage;
                currentData = data.slice(total - this.perPage, total);
            }
            return currentData;
        },
        rows(){
            let data = this.fees;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.name
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            return data.length;
        },
        selectedFees(){
            let data = this.fees;
            return data.filter(x => x.selected);
        }
    },
    data(){
        return {
            filter: '',
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
        }
    },
    methods: {
        addSelectedFees(){
            this.$emit('selected-fees', this.selectedFees)
        }
    }
}
</script>
<template>
    <b-modal
        id="fee-template-modal"
        title="Fee List"
        size="lg"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <div class="d-flex justify-content-between mb-2">
            <div id="tickets-table_filter" class="dataTables_filter">
                <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        autocomplete="off"
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2 me-1"
                    ></b-form-input>
                    <select class="form-select form-select-sm" style="width:90px;">
                        <option v-for="x in pageOptions" :key="x">{{x}}</option>
                    </select>
                </label>
            </div>
            <div v-if="selectedFees.length">
                <button type="button" class="btn btn-success btn-sm" @click="addSelectedFees"><i class="bx bx-plus"></i> Add Selected Fees ({{selectedFees.length}})</button>
            </div>
        </div>
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th style="width:50px"></th>
                    <th>Fee Name &amp; Accounts</th>
                    <th>Default Amount</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="x in filtered" :key="x.id">
                    <td class="v-align-middle">
                        <i class="bx font-size-24" :class="{'text-green bx-check': x.selected}" ></i>
                    </td>
                    <td @click="x.selected = !x.selected" class="cursor-pointer">
                        <p class="mb-0">{{x.name}}</p>
                        <small>{{x.account.accountName}}</small>
                    </td>
                    <td>
                        {{formatCurrency(x.defaultAmount)}}
                    </td>
                </tr>
            </tbody>
        </table>
        <div
            class="
                dataTables_paginate
                paging_simple_numbers
                float-end
            "
        >
            <ul
                class="
                    pagination pagination-rounded
                    mb-0
                "
            >
                <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                ></b-pagination>
            </ul>
        </div>
    </b-modal>
</template>